import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import nl from "./nl.json";
import lt from "./lt.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      lt: { translation: lt },
    },
    fallbackLng: "nl",
    supportedLngs: ["nl", "lt"],
    // Resolve region variants (e.g. "lt-LT" from a Lithuanian device) to the base
    // language so first-time visitors land in the right language automatically.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "app_lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> in sync with the active language and reaffirm translate="no"
// so browsers do not offer to auto-translate (the cause of the white-screen bug).
const applyHtmlLang = (lng) => {
  try {
    document.documentElement.lang = (lng || "nl").split("-")[0];
    document.documentElement.setAttribute("translate", "no");
  } catch (err) { /* noop */ }
};
applyHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
